<template>
  <div v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <div class="list" style="margin-bottom: 10px;">
      <!-- <div style="position: absolute; top: 75px; left: 50%; transform: translateX(-50%);">
        <el-button @click="refreshData">刷新<i class="el-icon-refresh el-icon--right"></i></el-button>
      </div> -->
      <el-table :data="eventList"
        style="position: fixed; top: 70px;"
        :height="height"
        :empty-text="empty">
        <el-table-column
          type="index"
          width="35">
        </el-table-column>
        <!-- 活動名稱 -->
        <el-table-column label="活動">
          <template slot-scope="scope">
            <div style="font-weight: 500;">名稱: <span style="color: #444;">{{ scope.row[1].summary }}</span></div>
            <div style="font-weight: 500;">時間: <span style="color: #444;">{{ new Date(scope.row[1].start.dateTime).toLocaleString() }}</span></div>
            狀態:
            <span v-if="getStatus(scope.row[1]) === '未報名'" style="font-weight: 500;">{{ getStatus(scope.row[1]) }}</span>
            <span v-else-if="getStatus(scope.row[1]) === '待回覆'" style="font-weight: 500; color: #0b8be6;">{{ getStatus(scope.row[1]) }}</span>
            <span v-else style="font-weight: 500; color: #0dbd04;">{{ getStatus(scope.row[1]) }}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column width="100"
          label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="info" style="width: 80px; margin-bottom: 10px;" @click="bookEvent(scope.row)">查看</el-button>
            <el-button style="width: 80px;" size="mini" type="danger" v-if="getStatus(scope.row[1]) === '待回覆'" @click="undoBooking(scope.row)">取消報名</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 確認刪除 -->
    <mu-dialog :open="checkDel" width="550" title="確認訊息">
      <div>確定要取消報名嗎?</div>
      <mu-button slot="actions" flat color="primary" @click="checkDel = false">返回</mu-button>
      <mu-button slot="actions" color="primary" @click="checkUndo">確定</mu-button>
    </mu-dialog>
    <!-- 查看活動 -->
    <mu-dialog :open="openDia" width="550" :title="eventDetail.summary">
      <div style="padding-right: 5%;" v-if="!booking">
        <!-- 地點 -->
        <div id="location" style="margin-bottom: 5px;">
          <div style="font-size: 16px; font-weight: 500;">活動地點:</div>
          <mu-text-field disabled style="width: 100%;">{{ eventDetail.location }}</mu-text-field>
        </div>
        <!-- 地點 -->
        <div id="location" style="margin-bottom: 10px;">
          <div style="font-size: 16px; font-weight: 500; margin-bottom: 5px;">活動簡述:</div>
          <el-input type="textarea" v-model="eventDetail.description" :autosize="{ minRows: 2, maxRows: 4}"/>
        </div>
        <!-- 開始時間 -->
        <div id="location" style="margin-bottom: 5px;" v-if="eventDetail.start">
          <div style="font-size: 16px; font-weight: 500;">開始時間:</div>
          <mu-text-field disabled style="width: 100%;">{{ new Date(eventDetail.start.dateTime).toLocaleString() }}</mu-text-field>
        </div>
        <!-- 開始時間 -->
        <div id="location" style="margin-bottom: 5px;" v-if="eventDetail.end">
          <div style="font-size: 16px; font-weight: 500;">結束時間:</div>
          <mu-text-field disabled style="width: 100%;">{{ new Date(eventDetail.end.dateTime).toLocaleString() }}</mu-text-field>
        </div>
      </div>
      <div v-if="booking" style="max-height: 300px; overflow: auto; padding-right: 5%;">
        您的姓名:
        <mu-text-field v-model="name" style="width: 100%;"></mu-text-field>
        您的 Email(建議 @gmail):
        <mu-text-field v-model="email" style="width: 100%;"></mu-text-field>
        <div style="margin-top: -10px;">
          <el-checkbox v-model="remember">記住我</el-checkbox>
        </div>
        <div style="font-size: 15px; color: #f24;" v-if="showWarn">有資料漏填哦！</div>
      </div>
      <mu-button v-if="!booking" slot="actions" flat color="primary" @click="openDia = false">退出</mu-button>
      <mu-button v-if="!booking" slot="actions" color="primary" @click="booking = true" :disabled="eventMember">報名</mu-button>
      <mu-button v-if="booking" slot="actions" flat color="primary" @click="booking = false">返回</mu-button>
      <mu-button v-if="booking" slot="actions" color="primary" @click="sendBooking">確認</mu-button>
    </mu-dialog>
    <FlashMessage></FlashMessage>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      token: localStorage.getItem(this.$route.params.auth),
      email: '',
      name: '',
      eventList: [],
      selectId: '',
      openDia: false,
      checkDel: false,
      showWarn: false,
      booking: false,
      remember: false,
      pageLoading: false,
      eventDetail: {},
      empty: '載入中...'
    };
  },
  props: ['only', 'logo', 'userName', 'service', 'auth', 'calendar', 'userEmail', 'height'],
  mounted() {
    this.empty = '載入中...';
    this.getCalendar();
    this.email = this.userEmail;
    this.name = this.userName;
  },
  computed: {
    eventMember() {
      if (this.eventDetail.reserve) {
        const list = Object.values(this.eventDetail.reserve);
        if (list.length >= this.eventDetail.maxAttendees) {
          return true;
        }
        else if (list.map(el => el.token).indexOf(this.token) !== -1) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      updateUser: 'updateUser',
      checkAccount: 'checkAccount',
      sendBookEvent: 'sendBookEvent',
      undoEventBooking: 'undoEventBooking'
    }),
    col() {
      if (!this.logo || this.only) {
        return 24;
      }
      return 12;
    },
    bookEvent(row) {
      this.selectId = row[0];
      this.eventDetail = row[1];
      this.openDia = true;
    },
    refreshData() {
      this.empty = '載入中...';
      this.getCalendar();
      this.email = this.userEmail;
      this.name = this.userName;
    },
    getCalendar() {
      this.checkAccount({ Service: this.service, Auth: this.auth })
        .then((res) => {
          this.eventList = res.calender.events ? Object.entries(res.calender.events).sort((a, b) => new Date(a[1].start.dateTime) - new Date(b[1].start.dateTime)) : [];
          this.empty = '暫無活動';
        })
    },
    getStatus(row) {
      if (row.reserve) {
        if (row.reserve.hasOwnProperty(this.token)) {
          if (row.reserve[this.token].status) { return '已預訂' }
          else { return '待回覆' }
        }
        else { return '未報名' }
      }
      else { return '未報名' }
    },
    checkExist(row) {
      if (row.reserve && Object.values(row.reserve).map(el => el.token).indexOf(this.token) !== -1) {
        return true;
      }
      return false;
    },
    undoBooking(row) {
      this.selectId = row[0];
      this.checkDel = true;
    },
    checkUndo() {
      this.pageLoading = true;
      this.checkDel    = false;
      this.undoEventBooking({ service: this.service, auth: this.auth, eventId: this.selectId, token: this.token })
        .then(() => {
          this.getCalendar();
          this.pageLoading = false;
        })
    },
    saveUserData() {
      const postData = {
        Service: this.service, Auth: this.auth,
        Token: this.token,
        UpdateData: {
          Name: this.name, Email: this.email
        }
      }
      this.updateUser(postData);
    },
    checkPush() {
      this.pageLoading = true;
      this.openDia     = false;
      this.booking     = false;
      const postData   = {
        service: this.service, auth: this.auth, eventId: this.selectId,
        userData: { email: this.email, displayName: this.name, token: this.token }
      };
      this.sendBookEvent(postData).then(() => {
        this.pageLoading = false;
        this.getCalendar();
        if (this.remember) {
          this.saveUserData();
        }
      })
    },
    sendBooking() {
      if (!this.name || this.name === '' || !this.email || this.email === '') {
        this.showWarn = true;
        return;
      }
      this.showWarn = false;
      this.checkPush();
    },
    OfficialSite() {
      window.open('https://www.eilis-ai.com/');
    }
  }
}
</script>

<style scoped>
  .list {
    max-width: 550px;
    margin: 0 auto;
  }
  .web {
    text-decoration: none;
    color: #888;
    transition: 0.2s;
    font-size: 13px;
  }
</style>